import React from 'react';

const SortableThead = (props) => {

    const getNextSort = (sort) => {
        let newSort = null;
        switch(sort) {
            case 'ASC': newSort = 'DESC'; break;
            case 'DESC': newSort = null; break;
            case null: newSort = 'ASC'; break;
            default:
                newSort = null;
        }

        return newSort;
    }

    const onClick = () => {
        if(props.onSortChange instanceof Function) {
            props.onSortChange( getNextSort(props.dir) )
        }
    }

    const getClassName = () => {
        return props.dir === 'ASC'
            ? 'fas fa-arrow-up'
            : props.dir === 'DESC'
                ? 'fas fa-arrow-down'
                : 'hidden';
    }

    return <th style={props.style ? props.style : {}} onClick={ onClick }>
        <div style={{cursor: 'pointer', whiteSpace: 'nowrap'}}>
            {props.children} <span className={getClassName()} ></span>
        </div>
    </th>
}

export default SortableThead;